import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Paper,
  IconButton,
  Input,
  InputLabel,
  TextField,
  FormControl,
  FormGroup,
  InputAdornment,
  Button,
} from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { pipe } from 'src/utils/pipe'
import FrameUnauthenticated from 'src/components/FrameUnauthenticated'
import StyledButton from 'src/assets/theme/buttons'
import { Creators } from 'src/redux/actions'
import { TransparentCurtain, Block } from 'src/assets/theme/containers'
import { Text } from 'src/assets/theme/text'
import { PRIMARY, LIGHT_RED } from 'src/assets/theme/colors'
import { validate, ruleRunner } from 'src/utils/validation'
import { required } from 'src/utils/validation/rules'

const loginButton = {
  margin: '25px 0 0',
  fontSize: '14px',
  fontFamily: 'Montserrat',
  textTransform: 'none',
  borderRadius: 0,
  backgroundColor: PRIMARY,
}

const fieldValidations = [
  ruleRunner('email', 'Email', required),
  ruleRunner('password', 'Password', required),
]

class Login extends PureComponent {
  static propTypes = {
    error: PropTypes.string,
    history: PropTypes.object,
    signInWithEmailRequest: PropTypes.func,
  }

  state = {
    email: '',
    password: '',
    isPasswordVisible: false,
    showErrors: false,
  }

  validationErrors = () => validate(this.state, fieldValidations)

  handleInputChange = ({ target: { value, name } }) => {
    this.setState({ [name]: value })
  }

  handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ isPasswordVisible: !state.isPasswordVisible }))
  }

  handleSignUpClick = () => {
    const { history } = this.props
    history.push('/auth/sign-up')
  }

  handleTermsAndConditionsClick = () => {
    const { history } = this.props
    history.push('/terms-and-conditions')
  }

  handleLoginWithEmail = () => {}

  handlePasswordRecoveryClick = () => {
    const { history } = this.props
    history.push('/auth/recover-password')
  }

  render() {
    const { isPasswordVisible, password, showErrors } = this.state
    const { error } = this.props
    const validationErrors = showErrors ? this.validationErrors() : {}
    return (
      <FrameUnauthenticated showPartnerLogos>
        <TransparentCurtain>
          <Block
            centered
            className="access-container"
            margin="30px 0 60px"
            onClick={(event) => {
              event.stopPropagation()
            }}
          >
            <Paper elevation={1} square style={{ padding: '15px' }}>
              <Text
                fontSize={22}
                fontWeight={500}
                textAlign="center"
                margin="5px 0 10px 0"
              >
                Log in to <br />
                Prospect Exchange
              </Text>

              <Block
                fluid
                margin="20px 0 10px"
                backgroundColor="#F6F6F6"
                padding="15px"
              >
                {error != null && (
                  <Text
                    fontSize={14}
                    fontWeight={500}
                    textAlign="center"
                    margin="5px 0 10px 0"
                    color={LIGHT_RED}
                    smallFontSize={14}
                  >
                    {error}
                  </Text>
                )}

                <Text
                  style={{ maxWidth: '220px' }}
                  fontSize={14}
                  fontWeight={500}
                  textAlign="center"
                  margin="5px auto 5px auto"
                  smallFontSize={13}
                  color={LIGHT_RED}
                >
                  <br />
                  Log in has been Disabled as we prepare for the next step of
                  our journey.
                </Text>

                <form onSubmit={this.handleLoginWithEmail}>
                  <FormControl
                    fullWidth
                    style={{
                      left: '50%',
                      transform: 'translateX(-50%)',
                      maxWidth: '220px',
                    }}
                    required
                  >
                    <FormGroup>
                      <TextField
                        required
                        fullWidth
                        variant="standard"
                        label="Email"
                        margin="dense"
                        name="email"
                        type="email"
                        error={!!validationErrors.email}
                        onChange={this.handleInputChange}
                      />
                      <FormControl variant="standard" margin="dense">
                        <InputLabel
                          error={!!validationErrors.password}
                          required
                          htmlFor="password"
                        >
                          Password
                        </InputLabel>
                        <Input
                          error={!!validationErrors.password}
                          id="password"
                          type={isPasswordVisible ? 'text' : 'password'}
                          value={password}
                          onChange={this.handleInputChange}
                          name="password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                disableRipple
                                aria-label="Toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                              >
                                {isPasswordVisible ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>

                      <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        style={loginButton}
                        disabled
                        onClick={this.handleLoginWithEmail}
                      >
                        Log in
                      </Button>
                    </FormGroup>
                  </FormControl>
                </form>
              </Block>

              <Text
                fontSize={12}
                fontWeight={500}
                textAlign="center"
                margin="5px 0 5px 0"
              >
                <StyledButton
                  margin="0 auto"
                  style={{ padding: '0 0 7px' }}
                  onClick={this.handlePasswordRecoveryClick}
                >
                  <Text
                    fontSize={12}
                    fontWeight={500}
                    textAlign="center"
                    color={PRIMARY}
                    inline
                  >
                    Forgot password?
                  </Text>
                </StyledButton>
              </Text>

              <Text
                fontSize={12}
                fontWeight={500}
                textAlign="center"
                margin="5px 0 5px 0"
              >
                Don't have an account?
                <StyledButton
                  margin="0 5px"
                  style={{ padding: '0 0 7px' }}
                  onClick={this.handleSignUpClick}
                >
                  <Text
                    fontSize={12}
                    fontWeight={500}
                    textAlign="center"
                    color={PRIMARY}
                    inline
                  >
                    Sign up here
                  </Text>
                </StyledButton>
              </Text>

              <Text
                fontSize={12}
                fontWeight={500}
                textAlign="center"
                margin="5px 0 5px 0"
              >
                By logging in or signing up, you agree to our
                <Text
                  fontSize={12}
                  fontWeight={500}
                  textAlign="center"
                  margin="0 5px"
                  inline
                  color={PRIMARY}
                  style={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={this.handleTermsAndConditionsClick}
                >
                  Terms and conditions
                </Text>
              </Text>
            </Paper>
          </Block>
        </TransparentCurtain>
      </FrameUnauthenticated>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  error: auth.signInError,
})

const mapDispatchToProps = {
  signInWithEmailRequest: Creators.signInWithEmailRequest,
}

export default pipe(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Login)
